import { Link } from "react-router-dom";
import ProfawzLogo from "../../components/ProfawzLogo";

export default function LegalLayout({ title, eyebrow, lastUpdate, children }) {
    return (
        <div className="min-h-screen bg-paper">
            <header className="sticky top-0 z-30 bg-white/95 backdrop-blur border-b border-rule">
                <div className="max-w-7xl mx-auto flex items-center justify-between px-6 lg:px-10 h-16">
                    <Link to="/" className="flex items-center gap-2.5">
                        <ProfawzLogo size={28} />
                        <span className="h-display text-lg font-semibold tracking-tight">Profawz</span>
                    </Link>
                    <nav className="flex items-center gap-5 text-xs font-mono text-muted2">
                        <Link to="/mentions-legales" className="hover:text-ink">Mentions légales</Link>
                        <Link to="/cgv" className="hover:text-ink">CGV</Link>
                        <Link to="/cgu" className="hover:text-ink">CGU</Link>
                        <Link to="/confidentialite" className="hover:text-ink">Confidentialité</Link>
                        <Link to="/cookies" className="hover:text-ink" data-testid="legal-header-cookies">Cookies</Link>
                        <Link to="/contact" className="hover:text-ink">Contact</Link>
                    </nav>
                </div>
            </header>
            <main className="max-w-3xl mx-auto px-6 lg:px-10 py-12">
                <Link to="/" className="text-xs font-mono text-muted2 hover:text-ink">← Retour à l'accueil</Link>
                <div className="label-eyebrow mt-4 mb-2">{eyebrow}</div>
                <h1 className="h-display text-4xl sm:text-5xl font-semibold leading-tight">{title}</h1>
                {lastUpdate && (
                    <div className="text-xs font-mono text-muted2 mt-3">Dernière mise à jour : {lastUpdate}</div>
                )}
                <div className="mt-10 prose prose-sm max-w-none legal-prose">{children}</div>
            </main>
            <footer className="py-10 border-t border-rule mt-16">
                <div className="max-w-7xl mx-auto px-6 lg:px-10 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs font-mono text-muted2">
                    <div>Profawz — © {new Date().getFullYear()}</div>
                    <div className="flex flex-wrap gap-4">
                        <Link to="/mentions-legales" className="hover:text-ink">Mentions légales</Link>
                        <Link to="/cgv" className="hover:text-ink">CGV</Link>
                        <Link to="/cgu" className="hover:text-ink">CGU</Link>
                        <Link to="/confidentialite" className="hover:text-ink">Confidentialité</Link>
                        <Link to="/cookies" className="hover:text-ink" data-testid="legal-nav-cookies">Cookies</Link>
                        <Link to="/contact" className="hover:text-ink">Contact</Link>
                    </div>
                </div>
            </footer>
        </div>
    );
}

export const LegalSection = ({ number, title, children }) => (
    <section className="mt-10">
        <div className="flex items-baseline gap-3 pb-3 border-b border-rule">
            <span className="text-xs font-mono text-orange font-bold">{number}</span>
            <h2 className="h-display text-xl font-semibold">{title}</h2>
        </div>
        <div className="mt-4 space-y-3 text-[15px] leading-relaxed text-ink/85">{children}</div>
    </section>
);
